import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/components/home'
import about from '@/components/about'
import application from '@/components/application'
import newCase from '@/components/case'
import download from '@/components/download'
import contact from '@/components/contact'
import newsList from '@/components/newsList'
import order from '@/components/order'
import Alpha from '@/components/Alpha'
import question from '@/components/question'
import news from '@/components/newsDetail/news'
import purchaseTerms from '@/components/purchaseTerms'
import developer from '@/components/developer'
import Beacons from '@/components/Beacons'
Vue.use(Router)


export default new Router({
    mode:'history',
    routes: [
        {path: '/', name: 'home', component: home},
        {path: '/en', name: 'home', component: home},
        {path: '/en/about', component: about},
        {path: '/en/application', component: application},
        {path: '/en/case', component: newCase},
        {path: '/en/download', component: download},
        {path: '/en/contact', component: contact},
        {path: '/en/newsList', component: newsList},
        {path: '/en/order', component: order},
        {path: '/en/Alpha', component: Alpha},
        {path: '/en/Beacons', component: Beacons},
        {path: '/en/question', component: question},
        {path: '/en/newsList/news/:bid',name:'detail1',component:news},
        {path: '/en/purchaseTerms',component:purchaseTerms},
        {path: '/en/developer',component:developer},
        {path: '*',redirect: '/'}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js